export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS = 'applicantProfileDocuments'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_EMPTY =
  'applicantProfileDocumentsEmpty'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_RETRY =
  'applicantProfileDocumentsRetry'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING =
  'applicantProfileDocumentsOutstanding'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_ITEM =
  'applicantProfileDocumentsOutstandingItem'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_MORE =
  'applicantProfileDocumentsOutstandingMore'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_TABLE =
  'applicantDocumentsTable'

export const APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_LIMIT = 6

export const APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_TEXT_COLOR =
  'var(--secondary-text-color)'

export const APPLICANT_PROFILE_DOCUMENTS_SKELETON_ROWS = 3

export const APPLICANT_DOCUMENTS_PAGE_SIZE = 20

export const APPLICANT_DOCUMENT_COLUMN_NAME = {
  Name: 'name',
  Size: 'size_bytes',
  Uploaded: 'uploaded_at',
  UploadedBy: 'uploaded_by',
}

export const APPLICANT_DOCUMENT_COLUMNS_CONFIG = {
  [APPLICANT_DOCUMENT_COLUMN_NAME.Name]: {
    index: 0,
    name: APPLICANT_DOCUMENT_COLUMN_NAME.Name,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsNameColumnKey',
    visible: true,
  },
  [APPLICANT_DOCUMENT_COLUMN_NAME.Size]: {
    index: 1,
    name: APPLICANT_DOCUMENT_COLUMN_NAME.Size,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsSizeColumnKey',
    visible: true,
    width: 110,
  },
  [APPLICANT_DOCUMENT_COLUMN_NAME.Uploaded]: {
    index: 2,
    name: APPLICANT_DOCUMENT_COLUMN_NAME.Uploaded,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedColumnKey',
    visible: true,
    width: 180,
  },
  [APPLICANT_DOCUMENT_COLUMN_NAME.UploadedBy]: {
    index: 3,
    name: APPLICANT_DOCUMENT_COLUMN_NAME.UploadedBy,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedByColumnKey',
    visible: true,
    width: 240,
  },
}

export const APPLICANT_DOCUMENTS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_FOLDER =
  'applicantDocumentsFolder'

export const APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT = 'applicant'
